import React, { useState, useEffect } from 'react';
import { Form, Button, Card, Alert, Spinner } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { useProvider, Toast, isNative } from '../../context/MenuProvider'


const LoginForm = () => {
  const { 
    site, 
    excluirDadosCompleto, 
    salvarDados,
    crud,
  } = useProvider();
  const { loading, get, post } = crud || {};
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [logado, setLogado] = useState(false);
  const [carregando, setCarregando] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  
  
  const handleSubmit = async (event) => {
    if(event) event.preventDefault();
    if (loading || carregando) return;

    if (username.trim() === '' || password.trim() === '') {
      setError('Por favor, preencha todos os campos.');
      return;
    }

    setError('');

    try {
      setCarregando(true);
      const loginData = { username, password };
      const response = await post(loginData, `/api/token/`); // Executando requisição

      if (response && response.length) {
        await excluirDadosCompleto();
        await salvarDados('local_registros', {
          ...response[0],
          id:"auth"
        });
        if (isNative) window.dispatchNativeMessage('login');
        if(!isNative) navigator.serviceWorker.controller.postMessage('login');
        // Mostrar mensagem de sucesso
        Toast.fire({
          icon: "success",
          title: "Login realizado com sucesso!",
        });
        //setLogado(true);
        navigate('/', { replace: true });
      }
    } catch (err) {
      Toast.fire({
        icon: "error",
        title: "Erro ao fazer login",
      });
      setError('Verifique suas credenciais e tente novamente.');
    }finally{
      setCarregando(false);
    }
  };

  return (
    <div className="login-container">
      <Card>
        <Card.Body>
          <h2 className="text-center border-dashed-bottom mb-4">Login</h2>
          <Form onSubmit={handleSubmit}>
            <Form.Group controlId="username" className="mb-3">
              <Form.Label>Usuário ou Email</Form.Label>
              <Form.Control
                type="text"
                value={username}
                disabled={loading || carregando}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="Nome de usuário"
              />
            </Form.Group>

            <Form.Group controlId="password" className="mb-3">
              <Form.Label>Senha</Form.Label>
              <Form.Control
                type="password"
                value={password}
                disabled={loading || carregando}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Senha de acesso"
              />
            </Form.Group>

            {error && <Alert variant="danger">{error}</Alert>}
            {(loading || carregando) && <div className="text-center"><Spinner animation="border" /></div>}

            <Button variant="secondary" type="submit" className="w-100" disabled={loading}>
              {(loading || carregando) ? 'Carregando...' : 'Login'}
            </Button>
            {!(loading || carregando) && (<>
              <div className="text-center pt-3">
                <Link to="/login/recuperar-senha/" className="btn btn-sm w-100 btn-outline-secondary">
                  Recuperar Senha
                </Link>
              </div>
            </>)}
          </Form>
        </Card.Body>
      </Card>
    </div>
  );
};

export default LoginForm;